export const morningstarKeyInfoLink = (isin: string) => {
  if (isin === "LU2491551870") {
    return `https://doc.morningstar.com/LatestDoc.aspx?clientid=norne&key=388b5494c68c4cf1&investmentid=F00001EWQA&documenttype=299&language=467`;
  } else if (isin === "LU2491552092") {
    return `https://doc.morningstar.com/LatestDoc.aspx?clientid=norne&key=388b5494c68c4cf1&investmentid=F00001EWQC&documenttype=299&language=467`;
  }

  return `https://doc.morningstar.com/LatestDoc.aspx?clientid=norne&key=388b5494c68c4cf1&isin=${isin}&documenttype=299&language=467`;
};
